/**
 * Subset of LANGUAGES we currently auto-generate dubs and subtitles for
 * via ElevenLabs. Add a code here once the pipeline is validated for it.
 */
export const GENERATION_LANGS = ["de", "en", "fr", "es", "pl", "hi"] as const;
export type GenerationLang = (typeof GENERATION_LANGS)[number];

/** BCP-47 codes Stream accepts for captions and audio labels. */
export const LANGUAGES: { code: string; name: string }[] = [
  { code: "en", name: "English" },
  { code: "de", name: "German (Deutsch)" },
  { code: "es", name: "Spanish (Español)" },
  { code: "fr", name: "French (Français)" },
  { code: "it", name: "Italian (Italiano)" },
  { code: "pt", name: "Portuguese (Português)" },
  { code: "pt-br", name: "Portuguese — Brazil" },
  { code: "nl", name: "Dutch (Nederlands)" },
  { code: "pl", name: "Polish (Polski)" },
  { code: "ru", name: "Russian (Русский)" },
  { code: "tr", name: "Turkish (Türkçe)" },
  { code: "ja", name: "Japanese (日本語)" },
  { code: "ko", name: "Korean (한국어)" },
  { code: "zh", name: "Chinese (中文)" },
  { code: "ar", name: "Arabic (العربية)" },
  { code: "hi", name: "Hindi (हिन्दी)" },
];

export function languageName(code: string) {
  return LANGUAGES.find((l) => l.code.toLowerCase() === code.toLowerCase())?.name ?? code;
}
